const anchoCoberturas = 450;
const anchoPlanes = 150;
const anchoTitulos = 146;
const largoPlanes = 840;
const largoRows = 66;
const anchoAdicionales = 475;
const largoPlanes2 = 400;
const fontFamily= 'Futura'

const styles = {

    cardDatosVehiculo: {
        width: '100%',
        height: 'auto',
        marginTop: "20px",
        padding: '10px',
        backgroundColor: "#f2f2f2"
    },
    elipse: {
        width: 20,
        height: 20,

        shadowRadius: 2,
        shadowOpacity: 1,
        borderStyle: "solid",
        borderRadius: 40 / 2,
        borderWidth: 0.5,
        borderColor: "#ededed",
        backgroundColor: '#ffffff',
        marginRight: '10px',
        boxShadow: `1px 1px 1px #9E9E9E`,
        cursor: "pointer",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    elipseText: {
        fontSize: 11,
        fontWeight: "normal",
        fontStyle: "normal",
        textAlign: "center",
        color: "#000000"
    },
    popHeader: {
        backgroundColor: "#4ea3de",
        fontFamily: fontFamily,
        fontSize: 20,
        fontWeight: "normal",
        fontStyle: "normal",

        textAlign: "center",
        color: "#f2f2f2"
    },
    tituloVehiculo: {

        fontFamily: fontFamily,
        fontSize: 16,
        fontWeight: "bold",
        fontStyle: "normal",
        textAlign: "left",
        color: "#000000"
    },
    divPreguntas: {
        marginTop: "20px",
    },
    divPreguntas2: {
        marginTop: "80px",
    },

    pregunta: {
        width: 308,
        height: 21,
        fontFamily: fontFamily,
        fontSize: 16,
        fontWeight: "bold",
        fontStyle: "normal",
        letterSpacing: 0,
        textAlign: "left",
        color: "#000000"
    },
    subTituloVehiculo: {
        fontFamily: fontFamily,
        fontSize: 16,
        fontWeight: "normal",
        fontStyle: "normal",
        textAlign: "left",
        color: "#515253"
    },
    datosDelVehCulo: {
        width: 239,
        height: 32,
        fontFamily: fontFamily,
        fontSize: 24,
        fontWeight: "bold",
        fontStyle: "normal",
        letterSpacing: 0,
        textAlign: "left",
        color: "#000000"
    },
    divCoberturas: {
        display: 'flex',
        'overflow-x': 'auto',
        'overflow-y': 'hidden'
        // flexFlow: 'unset'
    },
    divTitulo: {
        width: anchoCoberturas,
        height: largoPlanes,
        backgroundColor: "#f9f9f9",
        marginRight: '10px'
    },
    divTituloEscondido: {
        width: anchoCoberturas,
        height: largoRows,
        backgroundColor: "#ffffff",
        marginRight: '10px'
    },
    divTitulo3: {
        width: anchoCoberturas,
        height: largoPlanes2,
        backgroundColor: "#f9f9f9",
        marginRight: '10px'
    },
    divTitulo2: {
        width: anchoAdicionales,
        height: largoPlanes2,
        backgroundColor: "#f9f9f9",
        marginRight: '10px'
    },
    divEncabezado: {
        width: anchoCoberturas,
        height: largoRows,
        backgroundColor: "#4ea3de",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'

    },
    divEncabezado2: {
        width: anchoCoberturas,
        height: 45,
        backgroundColor: "#4ea3de",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'

    },
    divEncabezado3: {
        width: anchoAdicionales,
        height: largoRows,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'

    },
    tituloEncabezado: {
        width: 183,
        height: 48,
        fontFamily: fontFamily,
        fontSize: 36,
        fontWeight: "500",
        fontStyle: "normal",
        letterSpacing: 0,
        textAlign: "left",
        color: "#ffffff",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'

    },
    tituloEncabezado2: {
        width: anchoCoberturas,
        height: 48,
        fontFamily: fontFamily,
        fontSize: 24,
        fontWeight: "500",
        fontStyle: "normal",
        letterSpacing: 0,
        textAlign: "center",
        color: "#ffffff",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    divCategoria: {
        width: anchoPlanes,
        height: largoPlanes,
        borderStyle: "solid",
        borderColor: "#bdbdbd",
        marginRight: '10px'
    }
    ,
    divCategoriaSeleccionada: {
        width: anchoPlanes,
        height: largoPlanes,
        borderStyle: "solid",
        borderColor: "#001871",
        backgroundColor: "#ffffff",
        marginRight: '10px',


    },

    divContainerCategoriaSeleccionada: {
        width: anchoPlanes,
        height: 940,
        marginRight: '10px',


    },
    divCategoriaTitulo: {
        width: anchoTitulos,
        height: largoRows,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'


    },
    divCategoriaPrecio: {
        width: anchoPlanes,
        height: largoRows,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '10px'

    },
    botonActivo: {
        width: 164,
        height: 55,
        backgroundColor: "#001871",
        shadowColor: "rgba(0, 0, 0, 0.25)",
        shadowOffset: {
            width: 0,
            height: 4
        },
        shadowRadius: 4,
        shadowOpacity: 1,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#001871",
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: `3px 3px 1px #9E9E9E`,
        cursor: "pointer"

    },

    textoBotonActivo: {
        width: 'auto',
        height: 55,
        fontFamily: fontFamily,
        fontSize: 12,
        fontWeight: "bold",
        fontStyle: "normal",
        textAlign: "center",
        color: "#f2f2f2",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '10px',
        cursor: "pointer"
    },

    botonInactivo: {
        width: 164,
        height: 55,
        backgroundColor: "#f2f2f2",
        shadowColor: "rgba(0, 0, 0, 0.25)",
        shadowOffset: {
            width: 0,
            height: 4
        },
        shadowRadius: 4,
        shadowOpacity: 1,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#001871",
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: `3px 3px 1px #9E9E9E`,
        cursor: "pointer"

    },

    textoBotonInactivo: {
        width: 'auto',
        height: 55,
        fontFamily: fontFamily,
        fontSize: 12,
        fontWeight: "500",
        fontStyle: "normal",
        textAlign: "center",
        color: "#001871",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '10px',
        cursor: "pointer"
    },

    divCategoriaPrecio3: {
        width: anchoPlanes,
        height: 48,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'

    },
    divCategoriaPrecio2: {
        width: anchoCoberturas,
        height: largoRows,
        paddingLeft: '50px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

    },

    divCategoriaPrecio4: {
        width: anchoCoberturas,
        height: 48,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

    },
    divCategoriaPrecio5: {
        width: anchoCoberturas,
        height: largoRows,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

    },

    divBotonAgregar: {
        width: 200,
        height: 40,
        borderRadius: 8,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#001871"
    },

    textoBotonAgregar: {
        width: 200,
        height: 40,
        fontFamily: fontFamily,
        fontSize: 16,
        fontWeight: "bold",
        textAlign: "center",
        color: "#4ea3de",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    tituloCategoria2: {
        width: anchoCoberturas,
        height: largoRows,
        fontFamily: fontFamily,
        fontSize: 19,
        fontWeight: "500",
        fontStyle: "normal",
        letterSpacing: 0,
        textAlign: "left",
        color: "#000000",
        display: 'flex',
        alignItems: 'center',

    }
    ,
    tituloCoberturasMain: {
        width: anchoPlanes,
        height: largoRows,
        fontFamily: fontFamily,
        fontSize: 12,
        fontWeight: "500",
        fontStyle: "normal",
        letterSpacing: 0,
        textAlign: "center",
        color: "#000000",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },

    tituloCoberturasPrecio: {
        width: anchoPlanes,
        height: largoRows,
        fontFamily: fontFamily,
        fontSize: 22,
        fontWeight: "bold",
        fontStyle: "normal",
        letterSpacing: 0,
        textAlign: "center",
        color: "#001871",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },

    tituloCoberturasNoAplica: {
        width: anchoPlanes,
        height: largoRows,
        fontFamily: fontFamily,
        fontSize: 16,
        fontWeight: "bold",
        fontStyle: "normal",
        letterSpacing: 0,
        textAlign: "center",
        color: "#001871",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },

    divCheck: {
        width: 44,
        height: 44,
        borderRadius: 3,
        backgroundColor: "#4192d8",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    divCheckOut: {
        width: 44,
        height: 44,
        borderRadius: 3,
        backgroundColor: "#e0e0e0",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    check: {
        fontSize: '20',
        color: '#ffffff'

    }

}

export default styles;